import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { loadSymbolSyntheticEpic } from './_epics/loadSymbolSynthetic.epic';
import { loadSymbolSyntheticListEpic } from './_epics/loadSymbolSyntheticList.epic';
import { loadSourceSymbolsEpic } from './_epics/loadSourceSymbols.epic';
import { createSymbolSyntheticEpic } from './_epics/createSymbolSynthetic.epic';
import { updateSymbolSyntheticEpic } from './_epics/updateSymbolSynthetic.epic';
import { removeSymbolSyntheticEpic } from './_epics/removeSymbolSynthetic.epic';
import { startSymbolSyntheticProcessingEpic } from './_epics/startSymbolSyntheticProcessing.epic';
import { endSymbolSyntheticProcessingEpic } from './_epics/endSymbolSyntheticProcessing.epic';
import { exportSymbolSyntheticsEpic } from './_epics/exportSymbolSynthetics.epic';

export const symbolSyntheticEpic = safeCombineEpics(
  loadSymbolSyntheticEpic,
  loadSymbolSyntheticListEpic,
  loadSourceSymbolsEpic,
  createSymbolSyntheticEpic,
  updateSymbolSyntheticEpic,
  removeSymbolSyntheticEpic,
  startSymbolSyntheticProcessingEpic,
  endSymbolSyntheticProcessingEpic,
  exportSymbolSyntheticsEpic,
);
